import { Drawer, Input } from "antd";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { LuSearch } from "react-icons/lu";
import axios from "axios";
import { apiToken, baseUrl } from "../../utils/base_url";
import crossIcon from "../../assets/icons/cancelicon.png";
import { IoMenu } from "react-icons/io5";

const BlogListingNav = () => {
  // const navigate = useNavigate();

  const [navbarData, setNavbarData] = useState();
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const fetchNavbarData = async () => {
      try {
        const res = await axios.get(`${baseUrl}/api/blog-navbars`, {
          headers: {
            Authorization: `Bearer ${apiToken}`,
          },
        });
        console.log(res?.data?.data[0]);
        setNavbarData(res?.data?.data[0]);
      } catch (error) {
        console.log(error);
      }
    };

    fetchNavbarData();
  }, []);

  const onClose = () => {
    setOpen(false);
  };
  return (
    <>
      {/* Small Screen Nav Bar */}
      <Drawer
        onClose={onClose}
        className="bg-transparent"
        closeIcon={<img src={crossIcon} alt="" width={15} height={15} />}
        style={{ backdropFilter: "blur(5px)" }}
        open={open}
        placement="left"
      >
        <div className="d-flex flex-column gap-3 align-items-center ">
          <div className="d-flex align-items-center justify-content-center gap-4 ">
            <div className="d-flex align-items-center gap-4   flex-column  my-2 my-md-0">
              {navbarData?.links?.map((navLink, idx) => (
                <React.Fragment key={idx}>
                  <Link
                    className="fs-6 text-decoration-none "
                    style={{ color: navLink?.textColor }}
                    aria-current="page"
                    to={navLink?.link}
                  >
                    {navLink?.name}
                  </Link>
                </React.Fragment>
              ))}
            </div>
          </div>

          <div className="d-flex align-items-center  gap-4 ">
            <div className="d-flex align-items-center justify-content-center">
              <Input
                style={{ background: "#242535", width: "166px" }}
                className="rounded-3  text-white blog-nav-search py-2 px-3"
                type={navbarData?.fields?.type}
                placeholder={navbarData?.fields?.placeholder}
                suffix={<LuSearch color="#52525B" size={16} />}
              />
            </div>
          </div>
        </div>
      </Drawer>

      <nav
        className=" navbar  navbar-expand-lg nav-small-scrn"
        style={{ background: "#090D24" }}
      >
        <div className="container  justify-content-between align-items-center  px-5">
          <Link className="navbar-brand text-white fs-2" to="/blogs">
            <span dangerouslySetInnerHTML={{ __html: navbarData?.logo }} />
          </Link>

          <span className="cursor-pointer" onClick={() => setOpen(true)}>
            <IoMenu color="white" size={30} />
          </span>
        </div>
      </nav>
      {/* End Here */}

      {/* Large Screen Nav Bar */}
      <nav
        className=" navbar  navbar-expand-lg nav-big-scrn"
        style={{ background: "#090D24" }}
      >
        <div className="container  justify-content-evenly align-items-center  px-5">
          <Link className="navbar-brand text-white fs-2" to="/blogs">
            <span dangerouslySetInnerHTML={{ __html: navbarData?.logo }} />
          </Link>

          <div className="d-flex align-items-center  gap-4 ">
            <div className="d-flex align-items-center gap-4   flex-column flex-md-row my-2 my-md-0">
              {navbarData?.links?.map((navLink, idx) => (
                <React.Fragment key={idx}>
                  <Link
                    className="fs-6 text-decoration-none "
                    style={{ color: navLink?.textColor }}
                    aria-current="page"
                    to={navLink?.link}
                  >
                    {navLink?.name}
                  </Link>
                </React.Fragment>
              ))}
            </div>
          </div>

          <div className="d-flex align-items-center  gap-4 ">
            <div className="d-flex align-items-center justify-content-center">
              <Input
                style={{ background: "#242535", width: "166px" }}
                className="rounded-3  text-white blog-nav-search py-2 px-3"
                type={navbarData?.fields?.type}
                placeholder={navbarData?.fields?.placeholder}
                suffix={<LuSearch color="#52525B" size={16} />}
              />
            </div>
          </div>
        </div>
      </nav>
    </>
  );
};

export default BlogListingNav;
